// extracted by mini-css-extract-plugin
export default {"root":"NulsJmqKDzSyiCMtYF5L"};